<div class="row justify-content-between justify-content-md-start">
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Monthly Active Users"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.uniqueVisitorsAdjusted | roundsig}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Total Sessions"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.totalNoOfVisits | roundsig}}
    </h3>
    <hr class="m-0 mx-auto">
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Pages per Session"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.avgPagePerVisit | rounddecimal:1}}
    </h3>
  </div>
  <div class="col-4 col-lg-6 p-4 text-center">
    <h5 class="font-weight-bold label">
      <info-tooltip2 title="Session Duration"></info-tooltip2>
    </h5>
    <h3 class="mb-4 font-weight-bold value">
      {{data?.engagementMetrics?.avgSessionDuration | duration: 'ms':'mmss'}}
    </h3>
  </div>
</div>